import enLang from './entries/en-US';
import arLang from './entries/ar_SA';

const AppLocale: any = {
  en: enLang,
  ar: arLang,
};

export default AppLocale;
